import React, { useState } from "react";
import axios from "axios";
import styles from "./ForgotPassword.module.css";
import ForgotPasswordNotification from "./ForgotPasswordNotification";

const ForgotPasswordSMS = ({ email }) => {
  const [phone, setPhone] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleSMSSubmit = async () => {
    // Remove hyphens to check for a valid phone number
    const cleanPhone = phone.replace(/-/g, "");

    // Check if the phone field is empty
    if (cleanPhone.trim().length === 0) {
      setError("Phone number cannot be empty");
      return;
    }

    try {
      // Convert the clean phone string to a number
      const numericPhone = Number(cleanPhone);
      await axios.post("/login/password-reset", { email, phone: numericPhone });
      setSubmitted(true);
    } catch (err) {
      console.error(err);
      setError("Unable to Reset Password");
    }
  };

  const handlePhoneChange = (event) => {
    let input = event.target.value;
    // Remove all non-digit characters
    input = input.replace(/\D/g, "");

    // Insert hyphens after the 3rd and 6th digits for display purposes:
    if (input.length > 6) {
      input = input.replace(/(\d{3})(\d{3})(\d+)/, "$1-$2-$3");
    } else if (input.length > 3) {
      input = input.replace(/(\d{3})(\d+)/, "$1-$2");
    }

    // Clear any previous error when user starts typing
    if (input.length > 0 && error) {
      setError(null);
    }

    setPhone(input);
  };

  return (
    <>
      {submitted ? (
        <ForgotPasswordNotification SMS={true} />
      ) : (
        <div className={styles.notiContainer}>
          <p className={styles.formTitle}>Forgot Password</p>
          <p className={styles.lightText}>
            Please enter your mobile phone number below.
          </p>
          <strong className={styles.placementMargin}>
            Confirm Mobile Phone
          </strong>
          <input
            className={styles.smsInput}
            type="tel"
            value={phone}
            placeholder="000-000-0000"
            onChange={handlePhoneChange}
            inputMode="numeric"
          />

          {error && <p className={styles.errorMessage}>{error}</p>}
          <div className={styles.formSubmit}>
            <button
              type="button"
              className="btn primary"
              onClick={handleSMSSubmit}
            >
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ForgotPasswordSMS;
